// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cra-conformity-assessment-ce.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cra-conformity-assessment-ce',
  title: 'Conformity assessment, EU declaration and CE marking for products with digital elements',
  description:
    'For each product with digital elements (PDE) that is in scope, the manufacturer must complete an applicable conformity assessment (CRA Art. 32), draw up the EU declaration of conformity (Art. 28, 29), and affix the CE marking (Art. 30) before placing the PDE on the market. Records must be retained for at least 10 years (Art. 13(18)). A CE mark reference and a reference to the EU declaration of conformity must be recorded per product.',
  category: 'compliance',
  scfIds: ['SCF-AUD-001', 'SCF-AUD-002', 'SCF-GOV-011'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'per-product',
  perProductCriteria: [
    {
      type: 'product-conformity-refs-set',
      description: 'CE mark reference and EU declaration of conformity reference both set',
    },
  ],
  domainActions: [],
};
